import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Component, ViewChild, ElementRef, inject } from '@angular/core';
import { AlertController, MenuController, IonMenu, IonToolbar, IonContent, IonButtons, IonMenuButton, IonIcon, IonList, IonItem, IonMenuToggle, IonLabel, IonToggle } from '@ionic/angular/standalone';
import { LoginService, UserInfoDto } from '@uoa/auth';
import { shareReplay, take } from 'rxjs/operators';
import { UserService } from 'src/app/core/services/user.service';
import { NceaService } from 'src/app/core/services/ncea.service';
import { AsyncPipe } from '@angular/common';
import { close } from 'ionicons/icons';
import { addIcons } from 'ionicons';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    imports: [IonMenu,
      IonToolbar,
      IonContent,
      IonButtons,
      IonMenuButton,
      IonIcon,
      IonList,
      IonItem,
      IonLabel,
      IonMenuToggle,
      IonToggle,
      AsyncPipe]
})
export class MenuComponent {
  private readonly userService = inject(UserService);
  private readonly menuCtrl = inject(MenuController);
  private readonly loginService = inject(LoginService);
  private readonly nceaService = inject(NceaService);
  private readonly router = inject(Router);
  private readonly alertCtrl = inject(AlertController);

  loggedIn$: Observable<boolean>;
  user$: Observable<UserInfoDto>;
  hasNceaPermission$: Observable<boolean>;
  @ViewChild('title') title: ElementRef;

  constructor() {
    this.loggedIn$ = this.userService.loggedIn$;
    this.user$ = this.userService.user$;
    this.hasNceaPermission$ = this.nceaService.hasNceaPermission$.pipe(shareReplay(1));
    addIcons({close});
  }

  async toggleNceaPermission(): Promise<void> {
    await this.login();
    this.hasNceaPermission$.pipe(take(1)).subscribe(async (permission) => {
      this.nceaService.saveNceaPermission(!permission);
      if (permission === true) {
        sessionStorage.setItem('nceaPopupShown', permission.toString());
        const alert = await this.alertCtrl.create({
          header: 'Turn off permission to acess NZQA',
          message: 'Rank Score Calculator won\'t receive any future updates from  NZQA regarding your results.',
          buttons: [{ text: 'Close', role: 'cancel' }],
        });
        await alert.present();
      }
    });
  }

  handleEscapeKey(_event: KeyboardEvent): void {
    this.menuCtrl.close();
  }

  menuWillOpen(): void {
    if (this.title) {
      this.title.nativeElement.focus();
    }
  }

  async login() {
    await this.loginService.doLogin(this.router.url);
  }
}
